import { Button, Group } from '@mantine/core';
import Icon from '@ui/components/Icon/Icon';
import Text from '@ui/components/Text/Text';

import './ShareLinkButton.scss';

export type ShareLinkButtonProps = {
	showSuccessMessage: boolean,
	copyShareLink: () => void,
	disabled?: boolean
};

const BUTTON_STYLES = {
	root: {
		'&:disabled': {
			backgroundColor: 'transparent'
		}
	}
};

const ShareLinkButton = ( { showSuccessMessage, copyShareLink, disabled }: ShareLinkButtonProps ) => {
	const activeButtonColor = showSuccessMessage ? 'green.6' : 'blue.5';

	return (
		<Button
			variant="subtle"
			onClick={copyShareLink}
			disabled={disabled}
			color={activeButtonColor}
			h={18}
			p={0}
			compact
			styles={BUTTON_STYLES}
		>
			<Group spacing={2} noWrap>
				<Icon
					className="CopyLinkIcon"
					color={disabled ? 'dark.2' : activeButtonColor}
					icon="link"
					size={18}
				/>
				<Text variant="footnote-semibold">{showSuccessMessage ? 'Copied!' : 'Copy'}</Text>
			</Group>
		</Button>
	);
};

export default ShareLinkButton;
